import { render, staticRenderFns } from "./SubscribeToNewsletter.vue?vue&type=template&id=b3151a8c&scoped=true&"
import script from "./SubscribeToNewsletter.vue?vue&type=script&lang=js&"
export * from "./SubscribeToNewsletter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3151a8c",
  null
  
)

export default component.exports